const emailRegex = /^(?=.{10,})[a-zA-Z0-9]+(?:[._+-]*[a-zA-Z0-9]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
const passwordRegex = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[!@#$%^&*()_+}{"':;?/>.<,])(?=.{10,})/;
var nameregex = /^[a-zA-Z ]+$/;

export { emailRegex, nameregex, passwordRegex };



